// Договоры клиентов
import { create } from 'zustand';
import { getContracts, getContractById, addContract, updateContract, getContractsParams, getTodayContracts } from 'services';

export const useContractsStore = create((set) => ({
	contractsList: [],
	contractById: {}, // договор клиента
	contractId: null, // id договора
	filters: {},
	searchValue: '',
	loading: false,
	loadingSingle: false,
	getContracts: async (selectedCity) => {
		set({ loading: true });
		const contractsList = await getContracts(selectedCity);
		set({ contractsList, loading: false });
	},
	getTodayContracts: async (selectedCity) => {
		set({ loading: true });
		const contractsList = await getTodayContracts(selectedCity);
		set({ contractsList, loading: false });
	},
	getContractsParams: async (filters) => {
		set({ loading: true });
		const contractsList = await getContractsParams(filters);
		set({ contractsList, loading: false });
	},
	// Получить договор по ID
	getContractById: async (id) => {
		set({ loadingSingle: true });
		const contractById = await getContractById(id);
		set({ contractById, loadingSingle: false, contractId: contractById?.id });
	},
	// Добавить договор и получить его id
	addContract: async (contractData) => {
		const contract = await addContract(contractData);
		set({ contractId: contract?.id });
	},
	// Обновить договор
	updateContract: async (data) => {
		await updateContract(data);
	},
	// Добавить фильтр
	addFilter: (filter) => set((state) => ({ filters: { ...state.filters, ...filter } })),
	// Сбросить фильтры
	resetFilters: () => set({ filters: {} }),
	// Поиск значения в списке договоров
	setSearchValue: (value) => set({ searchValue: value }),
	// Очистить договор
	clearContract: () => set({ contractById: {} }),
	// Очистить id договора
	clearContractId: () => set({ contractId: null }),
}))